import DashboardIcon from '@/assets/Svg/dashboard.svg';
import TeamsIcon from '@/assets/Svg/teams.svg';
import { RouteConstants } from './route-constant';
import { CheckSvg, BatchCheckIcon } from '@/components/ui/SvgIcon';

export type NavigationChildItem = {
  title: string;
  href: string;
  isActive: boolean;
  isVisible: boolean;
};

export type NavigationItem = {
  title: string;
  icon: string;
  href: string;
  isActive: boolean;
  isVisible: boolean;
  children?: NavigationChildItem[];
};

// Iframe URLs
export const IFRAME_URLS = {
  CODE_GUARD: 'https://sandbox.dev.usemaia.com/#/',
  CODE_GUARD_LOCAL: 'http://localhost:3101/#/',
  CODE_GUARD_UAT: 'https://sandbox.uat.usemaia.com/#/',
  CODE_GUARD_PROD: 'https://sandbox.app.usemaia.com/#/',
} as const;

export const navigationItems = (
  currentPage: string,
  isAdmin: boolean,
  canViewDataExtraction: boolean = false,
): NavigationItem[] => {
  return [
    {
      title: 'Dashboard',
      icon: DashboardIcon,
      href: RouteConstants.ROUTE_HOME,
      isActive: currentPage === 'Dashboard',
      isVisible: true,
    },
    {
      title: 'Check',
      icon: CheckSvg,
      href: RouteConstants.ROUTE_CHECK,
      isActive: currentPage === 'Check',
      isVisible: false,
    },
    {
      title: 'Batch Check',
      icon: BatchCheckIcon,
      href: RouteConstants.ROUTE_BATCH_CHECK,
      isActive: currentPage === 'Batch Check',
      isVisible: isAdmin,
    },
    {
      title: 'Team',
      icon: TeamsIcon,
      href: RouteConstants.ROUTE_TEAM,
      isActive: currentPage === 'Team',
      isVisible: true,
      children: [
        {
          title: 'Feature configuration',
          href: RouteConstants.ROUTE_TEAM_CONFIGURE_FEATURES,
          isActive: currentPage === 'Feature configuration',
          isVisible: isAdmin,
        },
      ],
    },
    {
      title: 'Data Extraction',
      icon: BatchCheckIcon,
      href: RouteConstants.ROUTE_DATA_EXTRACTION,
      isActive: currentPage === 'Data Extraction',
      isVisible: canViewDataExtraction,
    },
  ];
};
